import React, { FC } from 'react';
import { Checkbox } from 'antd';
import Form, { FormComponentProps } from 'antd/lib/form';
import { ValidateQuestionnaire, Question } from './QuestionnaireForm';

interface Props extends FormComponentProps {
  question: Question;
  validator: ValidateQuestionnaire;
}

export const QuestionCheckbox: FC<Props> = ({ form, question, validator }): JSX.Element => (
  <Form.Item label={question.text} key={question.id} extra={question.helpText}>
    {form.getFieldDecorator(`questionnaire[0].${question.id}`, {
      rules: [{ required: question.required, message: 'required' }, { validator: validator }],
      // initialValue: question.initialValue,
    })(<Checkbox>{question.initialValue}</Checkbox>)}
  </Form.Item>
);
